export * from './layer-watcher';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/utils/index.ts